export default {
  app: {
    languagePopup: {
      title: 'Du er i øjeblikket på den engelske version af {logo}',
      subtitle: 'Vil du skifte til dit foretrukne sprog?',
      cta: 'Skift til {lang}',
    },
  },
};
